import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetConfig,
  trunkSetConfig,
  trunkGetFwocConfig,
  trunkGetIpConfig,
  trunkSetIpConfig,
} from "../store/admin/adminConfig";

const useAdminConfigStore = () => {
  const adminConfigStore = useRootState((state) => state.adminConfigStore);

  const dispatch = useAppDispatch();

  const boundGetConfig = useMemo(
    () => bindActionCreators(trunkGetConfig, dispatch),
    [dispatch]
  );
  const boundUpdateConfig = useMemo(
    () => bindActionCreators(trunkSetConfig, dispatch),
    [dispatch]
  );
  const boundGetFwocConfig = useMemo(
    () => bindActionCreators(trunkGetFwocConfig, dispatch),
    [dispatch]
  );
  const boundGetIpConfig = useMemo(
    () => bindActionCreators(trunkGetIpConfig, dispatch),
    [dispatch]
  );
  const boundSetIpConfig = useMemo(
    () => bindActionCreators(trunkSetIpConfig, dispatch),
    [dispatch]
  );

  return {
    adminConfigStore,
    getConfig: boundGetConfig,
    updateConfig: boundUpdateConfig,
    getFwocConfigNew: boundGetFwocConfig,
    getIpConfig: boundGetIpConfig,
    setIpConfig: boundSetIpConfig,
  };
};

export default useAdminConfigStore;
